// extracted by mini-css-extract-plugin
export const root = "apartment-modal-module--root--1Rh-F";
export const container = "apartment-modal-module--container--3UKrb";
export const controls = "apartment-modal-module--controls--3VGq6";
export const button = "apartment-modal-module--button--234bV";
export const controlsButton = "apartment-modal-module--controlsButton--cZ8LL";
export const zoomIn = "apartment-modal-module--zoomIn--2GnTj";
export const extras = "apartment-modal-module--extras--38RPX";
export const buttonText = "apartment-modal-module--buttonText--23IEm";